// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"antd-pro-toolbar","left":"antd-pro-left","right":"antd-pro-right"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/FooterToolbar/index.less
// module id = 370
// module chunks = 0 1